import { ProjectElementNode } from '@deltek/specification-client/core/Models/productListingDetail'

export interface ImportTypeInfo {
    isProjectImport: boolean
    isOMImport: boolean
    isMasterSpecClone: boolean
    importType: 'Project Import' | 'OM Import' | 'OM Clone' | 'None'
}

/**
 * Determines the import type of a project element node
 * @param node - The project element node to analyze
 * @returns Import type information including flags and a label
 */
export const getImportTypeInfo = (
    node: Partial<ProjectElementNode> | null | undefined
): ImportTypeInfo => {
    if (!node) {
        return {
            isProjectImport: false,
            isOMImport: false,
            isMasterSpecClone: false,
            importType: 'None',
        }
    }

    const isMasterSpecClone = node.isMasterSpecClone === true
    
    // Determine import type with priority: OM Clone > OM Import > Project Import
    // NOTE: Flags are mutually exclusive - a node can only be one type
    let importType: 'Project Import' | 'OM Import' | 'OM Clone' | 'None' = 'None'
    let isOMImport = false
    let isProjectImport = false

    if (isMasterSpecClone) {
        importType = 'OM Clone'
    } else if (node.isBpPublished === true) {
        // OM Import: isBpPublished is the authoritative flag for OM-imported families,
        // matching the OM badge check in the element tree (ElementItemCard).
        // Using iteration != null was too broad — old projects may have a stale
        // iteration reference but isBpPublished === false, so no OM badge and
        // the Product Library button should still be visible.
        importType = 'OM Import'
        isOMImport = true
    } else if (node.isImportedToProject === true) {
        importType = 'Project Import'
        isProjectImport = true
    }

    return { isProjectImport, isOMImport, isMasterSpecClone, importType }
}
